import React from 'react'

import * as Dialog from '@radix-ui/react-dialog'

import useTranslation from '../../context/hooks/useTranslation'
import { useScanMutation } from '../../redux/services/morning-scan'

export const ScanLoadingModal: React.FC = () => {
  const { t } = useTranslation()

  const [, { isLoading }] = useScanMutation({
    fixedCacheKey: 'scan',
  })

  return (
    <Dialog.Root open={isLoading} modal={false}>
      <Dialog.Portal>
        <Dialog.Overlay className="bg-indigo-scrim fixed inset-0 opacity-60 transition-colors" />
        <Dialog.Content className="animate-fade-up font-body text-h1 shadow-elevation-2 fixed inset-0 m-auto h-fit w-fit rounded-md bg-white p-4 text-indigo-50">
          <span className="animate-infinite animate-pulse">
            {t('RETURNS_SCAN.LOADING')}
          </span>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ScanLoadingModal
